/**
 * Resolve lat/lng from a free-text address via Google Geocoder.
 * Used when the partner typed an address instead of picking a Places suggestion.
 */
export function geocodeAddress(query) {
  const address = String(query || '').trim();
  if (!address) {
    return Promise.reject(new Error('empty_address'));
  }
  if (typeof window === 'undefined' || !window.google?.maps?.Geocoder) {
    return Promise.reject(new Error('geocoder_unavailable'));
  }
  return new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      const loc = results?.[0]?.geometry?.location;
      if (status === 'OK' && loc) {
        resolve({
          latitude: String(loc.lat()),
          longitude: String(loc.lng()),
        });
        return;
      }
      reject(new Error(status || 'geocode_failed'));
    });
  });
}
